import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import SlippingDeals from '@/components/reports/slipping-deals'
import { loadCrmPageProps } from '@/lib/crm-page'

const SlippingDealsPage: FC<Partial<CrmPageProps>> = ({ data, today }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''} title="Slipping deals" description="Open deals whose close date has already passed.">
            <PageHeader title="Slipping Deals" />
            <SlippingDeals />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<CrmPageProps> = async () => {
    return { props: await loadCrmPageProps() }
}

export default SlippingDealsPage
